import { render, staticRenderFns } from "./tags-input.vue?vue&type=template&id=b3d936ca&scoped=true&"
import script from "./tags-input.vue?vue&type=script&lang=js&"
export * from "./tags-input.vue?vue&type=script&lang=js&"
import style0 from "./tags-input.vue?vue&type=style&index=0&id=b3d936ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d936ca",
  null
  
)

export default component.exports